import * as Yup from "yup";
import { form } from "./form";
import { TRIGGER_RESPONSE_CODES } from "constants/flowDesigner";

const {
  formField: { method, credentialType, required, responseCode, credential, customResponseCode }
} = form;

const validations = Yup.object().shape({
  [method.name]: Yup.array().min(1, "Add atleast 1 http method").required(method.errorMsg),
  [credentialType.name]: Yup.string().when(required.name, {
    is: true,
    then: Yup.string().required(credentialType.errorMsg)
  }),
  [credential.name]: Yup.string().when([credentialType.name, required.name], {
    is: (credentialType, required) => required && credentialType,
    then: Yup.string().required(credential.errorMsg)
  }),
  [customResponseCode.name]: Yup.string().when(responseCode.name, {
    is: TRIGGER_RESPONSE_CODES.CUSTOM,
    then: Yup.string().required(customResponseCode.errorMsg)
  }),
  ["port"]: Yup.string().when([credentialType.name], {
    is: (credentialType) => credentialType === "redis",
    then: Yup.string()
      .test("is-number", "Port must be a number", (value) => parseInt(value))
      .required("Port is required")
  }),
  ["endpoint"]: Yup.string().when([credentialType.name], {
    is: (credentialType) => credentialType === "redis",
    then: Yup.string().required("Endpoint is required")
  }),
  ["topics"]: Yup.array().when([credentialType.name], {
    is: (credentialType) => credentialType === "redis",
    then: Yup.array().min(1, "Add atleast 1 topic").required("Add atleast 1 topic")
  })
});

export default validations;
